module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_photogenic-0821ad5409016fc9df08cdcff5673b90.webp";